import axiosInstanceWeb from "../network/axiosInstance";

export const API_GET_DASHBOARDS = async () => {
  return await axiosInstanceWeb
    .get("/dashboards/user")
    .catch((err) => err.response);
};

export const API_GET_SMARTVIEW_CONFIG = async () => {
  return await axiosInstanceWeb
    .get("/smartviews/configuration")
    .catch((err) => err.response);
};
